import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators, FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-card-edit',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './card-edit.component.html',
  styleUrl: './card-edit.component.scss'
})
export class CardEditComponent implements OnChanges, OnInit {
  @Input() sheet?: AbstractControl;
  @Input() column?: AbstractControl;
  fieldForm: FormGroup;
  allowedValueInput = '';
  allowedValues: string[] = [];

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal) {
    this.fieldForm = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      dataType: ['string', Validators.required],
      presence: ['occasional', Validators.required],
      example: [''],
      enumValues: [[]]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['column'] && this.column) {
      this.patchFormFromColumn(this.column);
    }
  }

  ngOnInit(): void {
    if (this.column) {
      this.patchFormFromColumn(this.column);
    }
    this.fieldForm.get('dataType')?.valueChanges.subscribe(() => {
      this.syncEnumValidators();
    });
    this.syncEnumValidators();
  }

  private patchFormFromColumn(column: AbstractControl): void {
    const options = column.get('options')?.value ?? [];
    this.allowedValues = Array.isArray(options) ? [...options] : [];
    this.allowedValueInput = '';
    this.fieldForm.patchValue({
      name: column.get('name')?.value ?? '',
      description: column.get('description')?.value ?? '',
      dataType: this.allowedValues.length ? 'enum' : (column.get('type')?.value ?? 'string'),
      presence: column.get('presence')?.value ?? 'occasional',
      example: column.get('example')?.value ?? '',
      enumValues: this.allowedValues
    });
  }

  addAllowedValue(): void {
    const value = this.allowedValueInput.trim();
    if (!value) {
      return;
    }

    this.allowedValues = [...this.allowedValues, value];
    this.allowedValueInput = '';
    this.fieldForm.patchValue({ enumValues: this.allowedValues });
  }

  removeAllowedValue(index: number): void {
    this.allowedValues = this.allowedValues.filter((_, idx) => idx !== index);
    this.fieldForm.patchValue({ enumValues: this.allowedValues });
    this.fieldForm.get('enumValues')?.updateValueAndValidity({ emitEvent: false });
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onSubmit(): void {
    this.syncEnumValidators();
    if (this.fieldForm.invalid) {
      this.fieldForm.markAllAsTouched();
      return;
    }

    const { enumValues, dataType, example, ...rest } = this.fieldForm.value;
    const isEnum = dataType === 'enum';
    this.activeModal.close({
      ...rest,
      dataType,
      ...(isEnum ? { enumValues } : { example })
    });
  }

  private syncEnumValidators(): void {
    const enumValuesControl = this.fieldForm.get('enumValues');
    const isEnum = this.fieldForm.get('dataType')?.value === 'enum';
    if (!enumValuesControl) {
      return;
    }
    if (isEnum) {
      enumValuesControl.setValidators([
        Validators.required,
        (control) => Array.isArray(control.value) && control.value.length > 0 ? null : { required: true }
      ]);
    } else {
      enumValuesControl.clearValidators();
    }
    enumValuesControl.updateValueAndValidity({ emitEvent: false });
  }
}
